import './registerServiceWorker'
import { i18n } from '@/plugins/i18n'
import '@/plugins/vue-composition-api'
import '@/styles/styles.scss'
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import * as Sentry from "@sentry/vue";
import store from './store'
import axiosIns from '@axios'

Vue.config.productionTip = false

// Offline: bind connectivity listeners and hydrate local state from IndexedDB.
store.dispatch('offline/initConnectivity')

// When connectivity drops while the app is already open, funnel the user to the
// offline home (the router guard only fires on navigation). Public/blank pages
// and the offline home itself are left alone.
store.watch(
  (state, getters) => getters['offline/isOnline'],
  isOnline => {
    if (isOnline) return
    const current = router.currentRoute
    if (current.name !== 'offline-home' && current.meta.layout !== 'blank') {
      router.push({ name: 'offline-home' }).catch(() => {})
    }
  },
)

if (process.env.VUE_APP_SENTRY_DSN) {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: process.env.VUE_APP_ENVIRONMENT,
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
    ],
    tracesSampleRate: 1.0,
  });
}


// Hydrate the offline snapshot list from IndexedDB BEFORE mounting: the router
// guard reads it to decide whether an offline deep-link/reload of an assessment
// detail is allowed. Mounting first would let the initial navigation run against
// an empty store and bounce a downloaded assessment to the offline home.
async function bootstrap() {
  try {
    await store.dispatch('offline/refreshOfflineState')
  } catch (e) {
    // IndexedDB unavailable — proceed; the guard's own idb fallback still applies.
  }
  new Vue({
    router,
    store,
    i18n,
    vuetify,
    axiosIns,
    render: h => h(App),
  }).$mount('#app')
}

bootstrap()
